module.exports = __webpack_public_path__ + "b6ccc01efdbd01e1eda5de0753937cc1.pdf";